// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__0hzHf","navList":"Menu_navList__SOIVE","navItem":"Menu_navItem__0qJ90","navLink":"Menu_navLink__k2P4d","active":"Menu_active__fcOKs"};